const AcquisitionNumberType = {
    Own: 1,
    SuperiorOrganizationUnit: 2,
    SecondaryAcquisitionNumber: 3,
    ShortInsuranceOrganizationUnitId: 4,
    OwnDivided: 5,
} as const

type AcquisitionNumberType = typeof AcquisitionNumberType[keyof typeof AcquisitionNumberType]

const AcquisitionNumberTypes: [AcquisitionNumberType, string][] = [
    [AcquisitionNumberType.Own, 'Vlastní'],
    [AcquisitionNumberType.SuperiorOrganizationUnit, 'Nadřízená organizační jednotka'],
    [AcquisitionNumberType.SecondaryAcquisitionNumber, 'Sekundární ziskatelské číslo'],
    [AcquisitionNumberType.ShortInsuranceOrganizationUnitId, 'Denní POV'],
    [AcquisitionNumberType.OwnDivided, 'Vlastní rozdělené'],
]

const getAcquisitionNumberTypeName = (type?: AcquisitionNumberType): string | undefined => {
    return AcquisitionNumberTypes.find(([key]) => key === type)?.[1]
}

export { AcquisitionNumberType, AcquisitionNumberTypes, getAcquisitionNumberTypeName }

